import React, {useEffect, useState} from 'react';
import styles from "./ratings.module.scss";
import {useTranslation} from 'react-i18next';
import Company from "./company/Company";
import {Tabs, Select, SelectProps, message as messageAnt} from "antd";
import Analyst from "./analyst/Analyst";
import {useAppDispatch, useAppSelector} from "../../store/store";
import {useTickerList} from "../../hooks/tickerList.hook";
import {loaderSlice} from "../../store/redusers/loaderSlice";
import {CountryExchange, CountryExchangeLabel} from "../../shared/countryExchange";
import GetHistory from "../testing/getHistory/GetHistory";

const Ratings = () => {

    const {t, i18n} = useTranslation();

    const dispatch = useAppDispatch()
    const {loading, getTickers, error, clearError} = useTickerList()

    const [companyIsActive, setCompanyIsActive] = useState(true) //активность вкладки Компании
    const [analystIsActive, setAnalystIsActive] = useState(false) //активность вкладки Аналитики

    //работа табов
    const itemsTab = [
        {key: 'company', label: 'Компании',},
        {key: 'analyst', label: 'Аналитики',},
    ];
    const changeTabHandler = (key: string) => {
        if (key === 'company') {
            if (!companyIsActive) {
                setCompanyIsActive(true)
                setAnalystIsActive(false)
            }
        } else if (key === 'analyst') {
            if (!analystIsActive) {
                setAnalystIsActive(true)
                setCompanyIsActive(false)
            }
        }
    };

    const {setStatus} = loaderSlice.actions

    const [optionsSelectCountryExchange, setOptionsSelectCountryExchange] = useState<SelectProps['options']>()
    const [countryExchange, setCountryExchange] = useState<CountryExchange | undefined>()
    const [tickerList, setTickerList] = useState<string[]>([])

    //установка статуса лодера
    useEffect(() => {
        dispatch(setStatus({isLoading: loading}))
    }, [loading])

    //формирование списка для селектора выбора страны фондовой биржи
    useEffect(() => {
        const optionsCountryExchange: SelectProps['options'] = []
        Object.keys(CountryExchange).forEach((country) => {
            const value = country
            //@ts-ignore
            const label = t(CountryExchangeLabel[country as keyof typeof CountryExchangeLabel])
            optionsCountryExchange.push({value: value, label: label})
        })
        setOptionsSelectCountryExchange(optionsCountryExchange)
    }, [CountryExchange])

    //выбор страны фондовой биржи
    const onChangeCountryExchange = (value: string) => {
        setCountryExchange(CountryExchange[value as keyof typeof CountryExchange])
    };

    //функция получения списка тикеров по выбранной стране
    const getTickerList = async (country: CountryExchange) => {
        try {
            const dataTickers = await getTickers(country)
            messageAnt.info(dataTickers.message)
            setTickerList(dataTickers.info)
        } catch (e) {
            if (e instanceof Error) {
                messageAnt.error(e.message);
            }
            setCountryExchange(undefined)
            clearError()
        }
    }

    //получение списка тикеров с сайта ru.investing.com в зависимости от выбранной страны
    useEffect(() => {
        if (countryExchange) {
            const func = async () => {
                await getTickerList(countryExchange)
            }
            func()
        }
    }, [countryExchange])

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <p className={styles.title}>Глобальные рейтинги</p>
                    <div className={styles.tabs}>
                        <Tabs defaultActiveKey="1" items={itemsTab} onChange={changeTabHandler}/>
                    </div>
                </div>
                <div className={styles.table}>
                    <h5>Фондовая биржа</h5>
                    <div className={styles.blockWrap}>
                        <p className={styles.title}>Выбор страны фондовой биржи</p>
                        <Select showSearch allowClear placeholder="Страна биржи" onChange={onChangeCountryExchange}
                                options={optionsSelectCountryExchange} style={{width: 306}} size={'small'}/>
                    </div>
                    {
                        countryExchange && tickerList.length !== 0 ?
                            <>
                                {
                                    companyIsActive && <Company country={countryExchange} tickerList={tickerList}/>
                                }
                                {
                                    analystIsActive && <Analyst country={countryExchange} tickerList={tickerList}/>
                                }
                            </>
                            :
                            countryExchange && tickerList.length === 0 &&
                            <p className={styles.tip}>Дождитесь загрузки данных!</p>
                    }
                </div>
            </div>
        </div>
    );
};

export default Ratings;